// Variant Duplicator
// Handles duplication of nested variant forms (for containers and wicks)

window.duplicateVariant = function(button) {
  // Find the variant card that contains this button
  const variantCard = button.closest('.nested-fields');

  // Clone the variant card
  const clonedVariant = variantCard.cloneNode(true);

  // Update the variant name to indicate it's a copy
  const nameInput = clonedVariant.querySelector('input[id*="name"]');
  if (nameInput && nameInput.value) {
    nameInput.value = nameInput.value + ' (Copy)';
  }

  // Clear the ID field if it exists (for new records)
  const idInputs = clonedVariant.querySelectorAll('input[id*="_id"]');
  idInputs.forEach(input => input.value = '');

  // Update all input IDs and names to use new unique identifiers
  const timestamp = new Date().getTime();

  clonedVariant.querySelectorAll('input, select, textarea').forEach(input => {
    // Update name attribute
    if (input.name) {
      input.name = input.name.replace(/\[\d+\]/, '[' + timestamp + ']');
    }

    // Update id attribute
    if (input.id) {
      input.id = input.id.replace(/_\d+_/, '_' + timestamp + '_');
    }

    // Clear destroy flag if present
    if (input.name && input.name.includes('_destroy')) {
      input.value = '';
    }
  });

  // Update labels' for attributes
  clonedVariant.querySelectorAll('label').forEach(label => {
    if (label.htmlFor) {
      label.htmlFor = label.htmlFor.replace(/_\d+_/, '_' + timestamp + '_');
    }
  });

  // Update price points container ID
  clonedVariant.querySelectorAll('div[id*="variant-"]').forEach(div => {
    if (div.id) {
      const newId = 'variant-' + timestamp + '-price-points';
      div.id = newId;

      // Update the corresponding link_to_add_association data attribute
      const addButton = clonedVariant.querySelector('a[data-association-insertion-node*="variant-"]');
      if (addButton) {
        addButton.setAttribute('data-association-insertion-node', '#' + newId);
      }
    }
  });

  // Insert the cloned variant after the original
  variantCard.parentNode.insertBefore(clonedVariant, variantCard.nextSibling);

  // Trigger cocoon's after-insert event for any initialization
  const container = variantCard.closest('#container-variants, #wick-variants');
  if (container) {
    const event = new CustomEvent('cocoon:after-insert', {
      detail: clonedVariant,
      bubbles: true
    });
    container.dispatchEvent(event);
  }
};

